import { jsx as _jsx } from "react/jsx-runtime";
import { Loading as SourLoading } from '@wayste/sour-ui';
const Loading = () => {
    return (_jsx("div", { className: "container mx-auto p-6", children: _jsx(SourLoading, { size: "h-12 w-12", className: "absolute inset-0 m-auto" }) }));
};
export default Loading;
//# sourceMappingURL=loading.js.map